import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import '@arco-design/web-react/dist/css/arco.css';
import Login from './Login';
import Home from './Home';
import Analysis from './Analysis';
import PrivateCustomer from './PrivateCustomer';

function App() {
  const token = localStorage.getItem('token');
  const isLoggedIn = !!token;
  console.log('App组件 - token:', token, 'isLoggedIn:', isLoggedIn);
  
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Routes>
  <Route path="/login" element={<Login />} />
  <Route path="/home" element={isLoggedIn ? <Home /> : <Navigate to="/login" replace />} />
  <Route path="/private-customer" element={isLoggedIn ? <PrivateCustomer /> : <Navigate to="/login" replace />} />
  <Route path="/analysis" element={isLoggedIn ? <Analysis /> : <Navigate to="/login" replace />} />
  <Route path="/analysis/:taskId" element={isLoggedIn ? <Analysis /> : <Navigate to="/login" replace />} />

  <Route path="/" element={isLoggedIn ? <Navigate to="/home" replace /> : <Login />} />
</Routes>
    </Router>
  );
}

export default App;